import SupportForm, { ISupportFormDetails } from 'components/Forms/Support';
import Modal from 'components/HOCS/Modal';
import PageHeader from 'components/PageHeader';
import Panel from 'components/Panel';
import StyledButton from 'components/StyledButton';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styled from 'styled-components';
import StyledHeading from 'typography/StyledHeading';
import Text from 'typography/StyledText';

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Header = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 24px 0px;
`;

const ModalPanel = styled(Panel)`
    width: 100%;
    min-width:300px;
    max-width: 400px;
    min-height: 200px;
    height: 100%:
    max-height: 300px;
    display:flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
`;

const StyledText = styled(Text)`
	font-weight: 700;
`;

const Page: React.FC = () => {
	const router = useRouter();
	const {
		booking_id = '',
		enquiry_type = '',
		name = '',
		email = '',
		comments = '',
		property_id = 'Not provided',
	} = router.query;

	const [message, setMessage] = useState('');
	const [disableSubmit, setDisableSubmit] = useState(false);

	const submitForm = async (details: ISupportFormDetails, resetForm: any) => {
		setDisableSubmit(true);
		const subject = 'Direct Bookings Support';
		const message = `Enquiry: ${details.enquiryType}\nName: ${details.name}\nEmail: ${details.email}\nBooking Id: ${details.bookingId}\nComments: ${details.comments}\nProperty Id: ${property_id}`;

		const response = await fetch('/api/email', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ subject, message }),
		});
		setDisableSubmit(false);
		if (response.status === 200) {
			setMessage('Thanks, Your enquiry has been sent');
			resetForm();
		} else {
			setMessage('Error sending enquiry');
		}
	};

	const defaultFormValues = {
		name: name as string,
		enquiryType: enquiry_type as any,
		email: email as string,
		bookingId: booking_id as string,
		comments: comments as string,
	};

	return (
		<Container>
			<Head>
				<title>Travelnest Direct Bookings Support</title>
				<meta
					name="description"
					content="Travelnest Direct Bookings Support"
				/>
			</Head>
			<PageHeader />
			<Header>
				<StyledHeading type="h1">
					Submit a support request
				</StyledHeading>
			</Header>
			<Panel>
				<SupportForm
					onSubmit={submitForm}
					disableSubmit={disableSubmit}
					defaultValues={defaultFormValues}
				/>
				{message ? (
					<Modal show={!!message}>
						<ModalPanel>
							<StyledText type="lead">{message}</StyledText>
							<StyledButton
								title="OK"
								handleClick={() => setMessage('')}
							/>
						</ModalPanel>
					</Modal>
				) : null}
			</Panel>
		</Container>
	);
};

export default Page;
